import { UIHeading1, UIHeading4, UIText2 } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';

import { CONTENT } from './content';
import * as styles from './styles.css';

export const FAQAgent: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1 color="text-inverted-default">Ответы на острые вопросы</UIHeading1>
      </div>
      <div className={styles['items']}>
        {CONTENT.map((item, i) => {
          return (
            <div key={i} className={clsx(styles['item'], styles[item.borderType])}>
              <div className={clsx(styles['question'], styles[item.borderType])}>
                <UIHeading4 color="text-inverted-default">{item.title}</UIHeading4>
              </div>
              <div className={styles['answer']}>
                <UIText2>{item.text}</UIText2>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles['bg-img']} />
    </div>
  );
};

FAQAgent.displayName = 'FAQAgent';
